module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/X1WQGr/tc-custom/9781617452703.jpg?1730637004344",
      "alt": "This image is the cover for the book Wen Redmond's Digital Fiber Art"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Wen Redmond's Digital Fiber Art\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_vm._v("Fine art meets fabric!  Compose, create, and print innovative art quilts starting from your own digital photographs—even those from your phone! Well-known fiber artist Wen Redmond starts with the tools and equipment you'll need—any image editing software and a standard inkjet printer—and teaches you to alter images, print them on a variety of fibers, and accentuate them with stitching. With a sense of adventure, even a beginner can apply these techniques to create new and innovative works of art.   - Transform your photographs into matchless works of art with mixed-media techniques and quilting  - Explore inkjet printing on almost anything! Design with fabric, paper, and other substrates  - Get photo editing, layering, and printing tips from respected fiber artist and teacher Wen Redmond  - Learn new approaches to digital printing—perfect for quilters, fabric and paper artists, digital artists, mixed-media artists, photographers, art teachers, and more")]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Wen Redmond\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    C&T Publishing, Inc.\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0